import { render } from "./wfm-number.vue?vue&type=template&id=6b9f8130&scoped=true"
import script from "./wfm-number.vue?vue&type=script&lang=js"
export * from "./wfm-number.vue?vue&type=script&lang=js"

import "./wfm-number.vue?vue&type=style&index=0&id=6b9f8130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9f8130"]])

export default __exports__